export const UPDATE_FILE_CLASS = 'UPDATE_FILE_CLASS';